import {loadStripe} from "@stripe/stripe-js";
import {Elements} from "@stripe/react-stripe-js";
import {SaveCardForm} from "./SaveCardForm";
import {useEffect, useState} from "react";
import {createStripeIntent} from "../../lib/api/stripe";
import {RefreshCw} from "lucide-react";

const stripePromise = loadStripe("pk_live_51ReiRHBSRvPwEFDnN25H1tVopNNRvQLRRTnrfiZ6pLNp6LvdcF2cYFUdnGIz2C5fQkxyIzIfe1ziulZRMrXJQoct00gpZ9Gmb8");

interface StripeProviderProps {
  email: string;
  priceId: string;
  onPaymentComplete: ({paymentMethodId, customerId, priceId}: {
    paymentMethodId: string,
    customerId: string,
    priceId: string
  }) => void;
}

export const StripeProvider = ({email, priceId, onPaymentComplete}: StripeProviderProps) => {
  const [clientSecret, setClientSecret] = useState<string>();
  const [customerId, setCustomerId] = useState<string>();

  useEffect(() => {
    async function loadIntent() {
      const data = await createStripeIntent(email, priceId);
      const {client_secret, customer_id} = data;
      console.log('data: ', data);
      setClientSecret(client_secret);
      setCustomerId(customer_id);
    }

    if (email && priceId) {
      loadIntent();
    }
  }, [email, priceId]);

  function handleCardSaved(paymentMethodId: string) {
    if (priceId && customerId) {
      return onPaymentComplete({
        paymentMethodId,
        customerId,
        priceId
      });
    }
  }

  if (!clientSecret) return (<div className="flex items-center justify-center space-x-2">
    <RefreshCw className="h-4 w-4 animate-spin"/>
    <span>Loading payment form…</span>
  </div>);

  return (
    <Elements
      stripe={stripePromise}
      options={{
        clientSecret,
        appearance: {
          theme: 'stripe',
        },
      }}
    >
      <SaveCardForm onCardSaved={handleCardSaved}/>
    </Elements>
  );
}
